/* eslint-disable */
import LocomotiveScroll from "locomotive-scroll";
import { callbacks } from "./scroll-call/callbacks";

class ScrollManager {

  constructor() {

    this.scroll = null;
    this._scrollTop = 0;
    this.docReadyInterval = null;
    this.backToTop = document.querySelector('#backToTop');

    this.init();

  }


  init() {

    this.scroll = new LocomotiveScroll({
      el: document.querySelector('[data-scroll-container]'),
      smooth: true,
      repeat: true, // Element in-view detection repeat.
      multiplier: 0.6,
      // resetNativeScroll: true,
    });

    this.scroll.on('scroll', (args) => this.onScroll(args) );
    this.scroll.on('call', (func, way, obj) => {

      // se esiste una callback la lancia
      if( typeof callbacks[func] !== 'undefined') {
        callbacks[func](way, obj);
      }

    });

    setInterval( () => {
      // if ( ! menu._scrolling ) {
      if( typeof this.backToTop === "undefined") {
        return;
      }

      // this.scroll.scroll è una istana di NativeScroll che locomotive internamente usa
      // this.scroll.scroll.isScrolling è una proprietà del locomotive che mi dice se
      // sta scrollando o meno
      if( ! this.scroll.scroll.isScrolling && this._scrollTop > window.innerHeight ) {
        this.backToTop.classList.add('active');
      } else {
        this.backToTop.classList.remove('active');
      }

      // }
    }, 500 );

    this.backToTop.addEventListener('click', e => {
      this.scroll.scrollTo("top",300);
    });

    // serve ad aggiornare locomotive quando il documento è ready
    // altrimenti non calcola correttamente l'altezza del contenitore
    this.docReadyInterval = setInterval( () => {

      // gli stati sono:  loading | interactive | complete

      if(document.readyState !== 'complete') {
        // se il documento non è pronto mettiamo la classe is-loading
        document.body.classList.add('is-loading');
      }

      if (document.readyState === 'complete') {

        // aggiorna le classi del body
        document.body.classList.remove('is-loading');
        document.body.classList.add('loaded');

        // aggiorna locomotive
        this.scroll.update();

        // elimina l'interval
        clearInterval(this.docReadyInterval);
      }

    }, 500);

  }

  onScroll(e) {

    // console.log(e);

    this._scrollTop = e.scroll.y;

    // this._toggleNavbar(e.scroll.y);

  }


}

export default ScrollManager;



// WEBPACK FOOTER //
// ./scripts/classes/scrollManager.js